export default __webpack_public_path__ + "static/media/Book_of_Gates.3180ccc8.mp4";